var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"panel"},[_c('div',{staticClass:"panel-body"},[_c('div',{staticClass:"panel-operate"},[_vm._t("panel_head_operate")],2),_vm._v(" "),_vm._t("panel_body")],2),_vm._v(" "),(_vm.showBottom)?_c('div',{staticClass:"panel-bottom"},[_vm._t("panel_bottom")],2):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2419742c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/panel/src/panel.vue
// module id = null
// module chunks = 